import apiClient from './client';
import type { Notification } from '@/types/notification';
import { parseNotification } from '@/types/notification';

/** 通知列表分页条数（与后端默认一致，全项目统一使用） */
export const NOTIFICATION_LIST_PAGE_SIZE = 20;

export const notificationApi = {
  list: async (params?: {
    unreadOnly?: boolean;
    cursor?: string;
    limit?: number;
  }): Promise<Notification[]> => {
    const data = (await apiClient.get<Record<string, unknown>[]>('/notifications', {
      params: {
        unreadOnly: params?.unreadOnly,
        cursor: params?.cursor,
        limit: params?.limit ?? NOTIFICATION_LIST_PAGE_SIZE,
      },
    })) as unknown as Record<string, unknown>[];
    return data.map(parseNotification);
  },

  unreadCount: async (): Promise<{ count: number }> => {
    return apiClient.get<{ count: number }>('/notifications/unread-count') as unknown as Promise<{
      count: number;
    }>;
  },

  markRead: (id: string) => apiClient.patch(`/notifications/${id}/read`),

  markAllRead: () => apiClient.patch('/notifications/read-all'),

  markActionTaken: (id: string) => apiClient.patch(`/notifications/${id}/action-taken`),

  approveResourceDelete: (id: string) =>
    apiClient.post<{ status: string }>(`/notifications/${id}/resource-delete/approve`),

  rejectResourceDelete: (id: string) =>
    apiClient.post<{ status: string }>(`/notifications/${id}/resource-delete/reject`),
};
